module.exports = __webpack_public_path__ + "static/domki2-ba37077a6dcadd6a7601665d42e1fa23.jpg";